import type { Eip1193Provider } from "./eip1193";
import { QuoteContractChecks } from "./quote-contract-checks";

/** Application lifetime, single active context; successful TTL is owned by checks. */
export class TradeQuoteCache {
  private entry: { scope: string; context: string; provider: Eip1193Provider; checks: QuoteContractChecks } | null = null;
  syncContext(context: string) { if (this.entry && this.entry.context !== context) this.clear(); }
  get(scope: string, provider: Eip1193Provider, providerForSignal: (signal: AbortSignal) => Eip1193Provider, context = scope) {
    if (this.entry?.scope !== scope || this.entry.provider !== provider) {
      this.clear();
      this.entry = { scope, context, provider, checks: new QuoteContractChecks(providerForSignal, true) };
    }
    return this.entry;
  }
  clear() { this.entry?.checks.clear(); this.entry = null; }
}
